import React, { useState, useRef, useEffect } from "react";
import { withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Skeleton from "../shared/skeleton";
import CreatableSelect from 'react-select/creatable';
import Textbox from "../_lib/input/textbox";
import Textarea from "../_lib/input/textarea";
import Modal from "../_lib/modal/modal";
import { submit, init } from '../../actions/a.inquiry-form';
import { notify } from "../../util";
import LoginForm from "./login-form/login-form";

const InquiryForm = (props) => {
    const formRef = useRef();
    const optionalQuestionsTitleRef = useRef();

    let initialState = {
        isSubmiting: false,
        ID: -1,
        UserId: -1,
        IsAuthenticated: null,
        FirstName: '',
        LastName: '',
        Mobile: '',
        Description: '',
        File: '',
        SuggestedTags: [],
        AllTags: [],
        QualityOrPrice: null,
        Guarantee: null,
        GuaranteeDuration: '',
        BrandIsImportant: null,
        PreferredBrand: '',
    }

    let windowWidth = document.body.getBoundingClientRect();

    const [formState, setFormState] = useState(initialState);
    const [readyToSubmit, setReadyToSubmit] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(false);
    const [reactSelectValue, setReactSelectValue] = useState([]);

    const handleSubmit = async (formState) => {
        let formData = new FormData(),
            { FirstName, LastName, Mobile, Description, QualityOrPrice, Guarantee, GuaranteeDuration, BrandIsImportant, PreferredBrand } = formState,
            { File } = formState;
        formData.append(`file`, new Blob([File], { type: 'application/octet-stream' }), File.name)
        formData.append(
            "Data",
            new Blob([JSON.stringify({ ID: -1, FirstName, LastName, Mobile, Description, SelectedTags: reactSelectValue, QualityOrPrice, Guarantee, GuaranteeDuration, BrandIsImportant, PreferredBrand })], {
                type: "application/json",
            })
        )

        props.submit(formData).then(res => {
            if (res?.status === 200)
                notify.show({ message: "استعلام شما با موفقیت ثبت شد، همکاران ما در اسرع وقت پیگیری لازم را انجام می دهند", type: "success" })
            else if (res?.status === 415)
                notify.show({ message: "نوع فایل بارگذاری شده معتبر نیست", type: "error" })
            setFormState((oldValue) => ({ ...oldValue, ID: Number(res.responseText) }))
        });
    };

    const handleSelectFile = (e) => {
        let file = e.target.files[0];
        if (file.size <= 10485760) {
            let splittedFileName = file.name.split(".");
            let fileExtension = `.${splittedFileName[splittedFileName.length - 1]}`;
            if (props.allowedExtensions.includes(fileExtension)) {
                setFormState((oldState) => ({ ...oldState, File: file }));
            }
            else {
                e.target.value = ""
                notify.show({ message: "نوع فایل معتبر نیست", type: "error" })
            }
        } else {
            e.target.value = ""
            notify.show({ message: "حجم فایل ارسالی باید حداکثر ۱۰ مگابایت باشد", type: "error" })
        }
    };

    const handleAccordion = (e) => {
        if (!optionalQuestionsTitleRef.current.classList.contains('open')) {
            optionalQuestionsTitleRef.current.classList.add('open');
            $(".optional-questions").slideToggle("slow")
        }
        else {
            optionalQuestionsTitleRef.current.classList.remove('open');
            $(".optional-questions").slideToggle("slow")
        }
    };

    const reactSelectHandleChange = (_, action) => {
        switch (action.action) {
            case "select-option":
                setReactSelectValue((oldValue) => ([...oldValue, action.option]))
                break;

            case "remove-value":
                setReactSelectValue((oldValue) => ([...oldValue.filter(o => o.value !== action.removedValue.value)]));
                break;

            case "create-option":
                let newOption = { value: -1, label: action.option.label, __isNew__: true }
                setReactSelectValue((oldValue) => ([...oldValue, newOption]));
                break;

            case "clear":
                setReactSelectValue([]);
                break;

            default:
                break;
        }
    };

    const suggestedTagsHandleClick = (e) => {
        const suggestedOption = { value: Number(e.target.dataset.value), label: e.target.innerText }
        if (!reactSelectValue.find((item) => item.value === suggestedOption.value))
            setReactSelectValue((oldValue) => ([...oldValue, suggestedOption]))
    };

    const handleModalConfirm = () => {
        setFormState(initialState);
        setReactSelectValue([])
        props.init();
    }

    useEffect(() => {
        props.init();
    }, []);

    useEffect(() => {
        setFormState((oldState) => ({
            ...oldState,
            UserId: props.userId,
            IsAuthenticated: props.isAuthenticated,
            FirstName: props.firstName,
            LastName: props.lastName,
            Mobile: props.mobile,
            SuggestedTags: props.suggestedTags,
            AllTags: props.allTags
        }));
    }, [props.isFetching]);

    useEffect(() => {
        $(formRef.current).checkify({
            message: {
                position: "right",
                required: "پر کردن این فیلد الزامی است.",
                regex: "فرمت اطلاعات وارد شده صحیح نیست.",
                between: "فرمت اطلاعات وارد شده صحیح نیست.",
                number: "در این فیلد فقط می توانید عدد وارد کنید.",
                maxlen: "بیشترین تعداد کاراکتر مجاز {count} است.",
                minlen: "کمترین تعداد کاراکتر مجاز {count} است.",
            },
            onValid: (e) => {
                e.preventDefault();
                setShowLoginForm(!props.isAuthenticated);
                setReadyToSubmit(props.isAuthenticated);
                if (props.isAuthenticated)
                    setFormState((oldState) => ({ ...oldState, isSubmiting: true }));
            },
            onError: () => console.error(formState),
        })
    }, [formState]);

    useEffect(() => {
        if (readyToSubmit) {
            handleSubmit(formState);
            initialState.FirstName = (props.firstName != null && props.firstName !== '') ? props.firstName : '';
            initialState.LastName = (props.lastName != null && props.lastName !== '') ? props.lastName : '';
            initialState.Mobile = (props.mobile != null && props.mobile !== '') ? props.mobile : '';
            setFormState(initialState);
            setReadyToSubmit(false);
        }
    }, [readyToSubmit]);

    if (props.isFetching)
        return (
            <div className="inquiry__form-cn">
                <h4>فرم ثبت استعلام</h4>
                <Skeleton
                    align="center"
                    width={100}
                    schema={windowWidth > 767 ? skeletonSchema : mobileSkeletonSchema}
                    animation="blink"
                />
            </div>
        );

    if (showLoginForm)
        return (
            <LoginForm inquiryFormState={formState} handleInquirySubmit={handleSubmit} showLoginFormSetter={setShowLoginForm} />
        );

    return (
        <>
            <div className="inquiry__form-cn">
                <h4>فرم ثبت استعلام</h4>
                <form ref={formRef} className="inquiry__form">
                    <div className="row">
                        <div className="col-sm-4 form-group">
                            <Textbox
                                label="نام (الزامی)"
                                name="FirstName"
                                value={formState.FirstName}
                                onChange={(e) => { setFormState((oldState) => ({ ...oldState, FirstName: e.target.value })) }}
                                {...{ maxLength: 50, 'data-checkify': 'required' }}
                            />
                        </div>
                        <div className="col-sm-4 form-group">
                            <Textbox
                                label="نام خانوادگی (الزامی)"
                                name="LastName"
                                value={formState.LastName}
                                onChange={(e) => { setFormState((oldState) => ({ ...oldState, LastName: e.target.value })) }}
                                {...{ maxLength: 50, 'data-checkify': 'required' }}
                            />
                        </div>
                        <div className="col-sm-4 form-group">
                            <Textbox
                                label="شماره همراه (الزامی)"
                                name="Mobile"
                                value={formState.Mobile}
                                onChange={(e) => { setFormState((oldState) => ({ ...oldState, Mobile: e.target.value })) }}
                                {...{ maxLength: 11, 'data-checkify': 'required,number' }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12 form-group">
                            <Textarea
                                label="توضیحات (الزامی)"
                                name="Description"
                                value={formState.Description}
                                onChange={(e) => { setFormState((oldState) => ({ ...oldState, Description: e.target.value })) }}
                                {...{ maxLength: 1000, rows: 5, 'data-checkify': 'required' }}
                            />
                        </div>
                    </div>
                    <div className="row tag-cn">
                        <div className="col-sm-6 form-group">
                            <input name="File1" type="file" onChange={handleSelectFile} />
                        </div>
                        <div className="col-sm-6 form-group">
                            <CreatableSelect
                                isMulti
                                value={reactSelectValue}
                                onChange={reactSelectHandleChange}
                                options={formState.AllTags}
                                placeholder={<div className="react-select__placeholder">انتخاب برچسب</div>}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderColor: '#e5e6e7',
                                        borderRadius: '0',
                                    }),
                                }}
                            />
                            <div className="suggested-tags">
                                {formState.SuggestedTags.map((tag) => {
                                    return <span className="tag" key={`tag-${tag.value}`} onClick={(e) => suggestedTagsHandleClick(e)} data-value={tag.value}>{tag.label}</span>
                                })}
                            </div>
                        </div>
                    </div>
                    <div className="optional-questions-cn">
                        <h4 ref={optionalQuestionsTitleRef} onClick={(e) => { handleAccordion(e) }} className="optional-questions-title">
                            سوالات تکمیلی (اختیاری)
                            <span className="fa fa-times"></span>
                        </h4>
                        <div className="optional-questions">
                            <div className="margin-bottom">
                                <div>کدام یک از موارد زیر برای شما اهمیّت دارد؟</div>
                                <input
                                    name="QualityOrPrice"
                                    type="radio"
                                    value={0}
                                    id="quality"
                                    checked={formState.QualityOrPrice === 0}
                                    onChange={(e) => { setFormState((oldState) => ({ ...oldState, QualityOrPrice: Number(e.target.value) })) }}
                                />
                                <label htmlFor="quality">کیفیت</label>
                                <input
                                    name="QualityOrPrice"
                                    type="radio"
                                    value={1}
                                    id="price"
                                    checked={formState.QualityOrPrice === 1}
                                    onChange={(e) => { setFormState((oldState) => ({ ...oldState, QualityOrPrice: Number(e.target.value) })) }}
                                />
                                <label htmlFor="price">قیمت</label>
                                <input
                                    name="QualityOrPrice"
                                    type="radio"
                                    value={2}
                                    id="both"
                                    checked={formState.QualityOrPrice === 2}
                                    onChange={(e) => { setFormState((oldState) => ({ ...oldState, QualityOrPrice: Number(e.target.value) })) }}
                                />
                                <label htmlFor="both">هر دو</label>
                            </div>
                            <div className="margin-bottom">
                                <div>آیا در سازمان گارانتی محصول برای شما اهمیّت دارد؟</div>
                                <input
                                    name="GuaranteeIsImportant"
                                    type="radio"
                                    value={1}
                                    id="guaranteeYes"
                                    checked={formState.Guarantee === 1}
                                    onChange={(e) => {
                                        setFormState((oldState) => ({ ...oldState, Guarantee: Number(e.target.value) }));
                                        setFormState((oldState) => ({ ...oldState, GuaranteeDuration: 1 }))
                                    }}
                                />
                                <label htmlFor="guaranteeYes">بله</label>
                                <input
                                    name="GuaranteeIsImportant"
                                    type="radio"
                                    value={0}
                                    id="guaranteeNo"
                                    checked={formState.Guarantee === 0}
                                    onChange={(e) => {
                                        setFormState((oldState) => ({ ...oldState, Guarantee: Number(e.target.value) }))
                                        setFormState((oldState) => ({ ...oldState, GuaranteeDuration: '' }))
                                    }}
                                />
                                <label htmlFor="guaranteeNo">خیر</label>
                                {formState.Guarantee === 1 &&
                                    <div className="guarantee-selectbox">
                                        <select
                                            value={formState.GuaranteeDuration}
                                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, GuaranteeDuration: e.target.value })) }}
                                        >
                                            <option value={1}>یک سال</option>
                                            <option value={2}>دو سال</option>
                                            <option value={3}>سه سال</option>
                                            <option value={4}>چهار سال و بیشتر</option>
                                        </select>
                                    </div>
                                }
                            </div>
                            <div className="margin-bottom">
                                <div>آیا در این استعلام نشان تجاری کالا (برند) برای شما مهم است؟</div>
                                <input
                                    name="BrandIsImportant"
                                    type="radio"
                                    value={1}
                                    id="BrandYes"
                                    checked={formState.BrandIsImportant === 1}
                                    onChange={(e) => { setFormState((oldState) => ({ ...oldState, BrandIsImportant: Number(e.target.value) })) }}
                                />
                                <label htmlFor="BrandYes">بله</label>
                                <input
                                    name="BrandIsImportant"
                                    type="radio"
                                    value={0}
                                    id="BrandNo"
                                    checked={formState.BrandIsImportant === 0}
                                    onChange={(e) => { setFormState((oldState) => ({ ...oldState, BrandIsImportant: Number(e.target.value) })) }}
                                />
                                <label htmlFor="BrandNo">خیر</label>
                                {formState.BrandIsImportant === 1 &&
                                    <div className="PreferredBrand-textbox">
                                        <Textbox
                                            label="برند"
                                            name="PreferredBrand"
                                            value={formState.PreferredBrand}
                                            onChange={(e) => { setFormState((oldState) => ({ ...oldState, PreferredBrand: e.target.value })) }}
                                            {...{ maxLength: 500, 'data-checkify': 'required' }}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-3">
                            <button
                                disabled={formState.isSubmiting}
                                type="submit"
                                className="btn btn-info btn-block"
                            >
                                ثبت
                            </button>
                        </div>
                    </div>
                </form>
                {formState.UserId > 0 &&
                    <div className="complete-additional-info">
                        <p>اطلاعات تکمیلی مربوط به حساب کاربری خود را می توانید از <a href={`/پروفایل-کاربر/userId/${formState.UserId}`}>اینجا</a> کامل کنید</p>
                    </div>
                }
            </div>
            {formState.ID > 0 ?
                (props.isAuthenticated ?
                    <Modal
                        title="شماره استعلام"
                        body={`شماره استعلام شما: ${formState.ID}`}
                        confirmBtnText="تایید"
                        handleConfirm={() => handleModalConfirm()}
                    /> :
                    <Modal
                        title="شماره استعلام"
                        body={`شماره استعلام شما: ${formState.ID}`}
                        confirmBtnText="تایید و بارگیری مجدد صفحه"
                        handleConfirm={() => location.reload()}
                    />
                ) :
                null
            }
        </>
    );
};

const skeletonSchema = [[[31, 40]], [[31, 40]], [[31, 40]], [[100, 110]], [[48, 70]], [[48, 70]], [[100, 40]], [[20, 40]]];
const mobileSkeletonSchema = [[[100, 40]], [[100, 40]], [[100, 40]], [[100, 110]], [[100, 70]], [[100, 70]], [[100, 40]], [[100, 40]]];

const mapDispatchToProps = dispatch => {
    return {
        submit: (data) => dispatch(submit(data)),
        init: () => dispatch(init()),
    };
};

const mapStateToProps = state => {
    const { isFetching, userId, isAuthenticated, firstName, lastName, mobile, allowedExtensions, suggestedTags, allTags } = state.Inquiry;

    return {
        isFetching,
        userId,
        isAuthenticated,
        firstName,
        lastName,
        mobile,
        allowedExtensions,
        suggestedTags,
        allTags
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InquiryForm));